var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "vueModal",
    attrs: {
      "name": _vm.modalName,
      "pivotY": 0.15,
      "width": _vm.widthModal,
      "height": "auto",
      "scrollable": true,
      "click-to-close": _vm.clickToClose,
      "classes": ['generic-modals', 'v--modal']
    },
    on: {
      "before-open": _vm.beforeOpenAction,
      "opened": _vm.openedAction
    }
  }, [_c('div', {
    staticClass: "content-modal content"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.translations[_vm.title]))]), _c(_vm.contentComponent, _vm._b({
    ref: "contentComponent",
    tag: "component",
    attrs: {
      "paramsContentComponent": _vm.paramsContentComponent
    }
  }, 'component', _vm.dataComponent, false)), _vm.showCloseIcon ? _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button",
      "id": "close-button-".concat(_vm.modalName),
      "title": "Close"
    },
    on: {
      "click": function click($event) {
        return _vm.$modal.hide(_vm.modalName);
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]) : _vm._e(), _c('div', {
    staticClass: "CTA-wrapper row text-center"
  }, [_vm.ctaButton && _vm.closeButton ? _c('div', {
    staticClass: "small-10 large-8 center-column columns"
  }, [_c('div', {
    staticClass: "large-5 columns"
  }, [_c('button', {
    staticClass: "button secondary",
    attrs: {
      "aria-label": _vm.translations[_vm.closeButton],
      "type": "button",
      "id": "closeButton-".concat(_vm.modalName)
    },
    on: {
      "click": function click($event) {
        return _vm.$modal.hide(_vm.modalName);
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translations[_vm.closeButton]) + "\n          ")])]), _c('div', {
    staticClass: "large-5 columns set-right-justified"
  }, [_c('button', {
    staticClass: "button primary configurator2-replace-current-design-save",
    attrs: {
      "type": "button",
      "id": "ctaButton-".concat(_vm.modalName)
    },
    on: {
      "click": _vm.ctaAction
    }
  }, [_vm._v("\n            " + _vm._s(_vm.translations[_vm.ctaButton]) + "\n          ")])])]) : _vm.ctaButton ? _c('div', {
    staticClass: "small-10 large-4 center-column columns"
  }, [_c('button', {
    staticClass: "button primary",
    attrs: {
      "type": "button",
      "id": "ctaButton-".concat(_vm.modalName),
      "aria-label": _vm.translations[_vm.ctaButton]
    },
    on: {
      "click": function click($event) {
        return _vm.ctaAction();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.translations[_vm.ctaButton]) + "\n        ")])]) : _vm._e()])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }